import { Outlet, createFileRoute } from "@tanstack/react-router";
import { TeamInvitePageShell } from "@/features/invite/components/TeamInvitePageShell";
import { validateTeamInviteSearch } from "@/features/invite/utils/teamInviteSearch";

export const Route = createFileRoute("/_app/team/invite")({
    component: TeamInviteLayout,
    validateSearch: validateTeamInviteSearch,
});

function TeamInviteLayout() {
    return (
        <TeamInvitePageShell>
            <Outlet />
        </TeamInvitePageShell>
    );
}
